import React, { FC } from 'react'

import { IconDocumentSvgProps } from './IconDocumentSvg.types'
import * as Styled from './styles/IconDocumentSvg.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentSvg: FC<IconDocumentSvgProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentSvgProps['size'],
  isResponsive = false,
}: IconDocumentSvgProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#71463330-f298-43ac-a281-2cd7d073f4c7__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M11.498 13.002h7.53V6' stroke='#0D0D0D' strokeLinejoin='round' />
          <path
            d='M20.75 5.06a4.265 4.265 0 0 0-2.775 1.028l-5.42 4.64a4.249 4.249 0 0 0-1.485 3.232v24.93c0 2.2 1.8 4 3.48 4H33c2.72 0 4-1.8 4-4V5.06H20.75Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M31.195 26.32h1.265v2.462s-3.447 1.178-3.945-1.857c-.5-3.078 1.465-3.715 1.848-3.805.227-.055 1.54-.25 1.97.735m-17.285 4.758s.725.595 2.042.515c.67-.04 1.595-.463 1.438-1.675a1.57 1.57 0 0 0-.663-.98 6.132 6.132 0 0 0-1.83-.878s-.98-.27-1-1.227a1.5 1.5 0 0 1 1.5-1.593 2.585 2.585 0 0 1 1.86.54m2.905-.21 2.27 5.802 2.142-5.802'
            stroke='#E60000'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='71463330-f298-43ac-a281-2cd7d073f4c7__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentSvg
